
export function traverseObject(root, callback) {

  const stack = [['', root]];

  while (stack.length !== 0) {

    const [path, obj] = stack.pop();

    if (Array.isArray(obj)) {
      obj.forEach((item, i) => {
        if (typeof item === 'object') {
          stack.push([ path + '[' + i + ']',  item])
        }
      });
    } else if (obj && typeof obj === 'object') {
      callback(obj, path);
      Object.keys(obj).forEach(key => {
        const item = obj[key];
        if (typeof item === 'object') {
          stack.push([path + (path?'.':'') + key, item]);
        }
      })
    }
  }
}